/*
 * Copyright (c) 2017 by Julian Feder, julian.feder@yahoo.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';

    angular
        .module('askApp')
        .controller('BoardPaymentDialogController', BoardPaymentDialogController);

    BoardPaymentDialogController.$inject = ['$timeout', '$scope', '$uibModalInstance', 'entity', 'BoardPayment', 'DateUtils', '$http', 'ProjectActive', 'DinghyEventActive'];

    function BoardPaymentDialogController ($timeout, $scope, $uibModalInstance, entity, BoardPayment, DateUtils, $http, ProjectActive, DinghyEventActive) {
        var vm = this;

        vm.payment = entity;
        vm.maxAmount = vm.payment.amount;
        if (vm.payment.parent !== null) {
            vm.maxAmount = vm.payment.amount + vm.payment.parent.amount;
        }
        vm.clear = clear;
        vm.save = save;
        vm.getDept = getDept;
        vm.copyPayment = copyPayment;
        vm.amountEditable = false;
        vm.projects = [vm.payment.project];
        vm.dinghyEvents = [vm.payment.dinghyEvent];
        vm.relationClosed = (vm.payment.project && vm.payment.project.closed) || (vm.payment.dinghyEvent && vm.payment.dinghyEvent.closed)

        if (!vm.relationClosed) {
            getProjects();
            getDinghyEvents();
        }

        $timeout(function (){
            angular.element('.form-group:eq(2)>input').focus();
        });

        function getProjects() {
            ProjectActive.get({userId: null}, function(data) {
                vm.projects = data;
            });
        }

        function getDinghyEvents() {
            DinghyEventActive.get({userId: null}, function(data) {
                vm.dinghyEvents = data;
            });
        }

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if(vm.payment.dept == "") {
                vm.payment.dept = null;
            }
            if(vm.payment.category == "") {
                vm.payment.category = null;
            }
            BoardPayment.update(vm.payment, onSaveSuccess, onSaveError);
        }

        function onSaveSuccess (result) {
            $scope.$emit('askApp:paymentUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        function getDept(val) {
            return $http.get('api/_search/depts/', {
                params: {
                    query: val
                }
            }).then(function(response){
                return response.data.map(function(item) {
                    return item;
                });
            });
        }

        function copyPayment() {
            $http.get('/api/payments/duplicate/', {
                params: {
                    paymentId: vm.payment.id
                }
            }).then(onSaveSuccess, onSaveError);
        }
    }
})();
